import { createGlobalStyle } from 'styled-components';

export const MobileFixes = createGlobalStyle`
  /* Prevent zoom on input focus on iOS */
  @media screen and (max-width: 768px) {
    input[type="text"],
    input[type="email"],
    input[type="password"],
    input[type="search"],
    textarea,
    select {
      font-size: 16px !important;
      transform: scale(1);
    }
  }

  /* Prevent horizontal scroll on mobile */
  @media screen and (max-width: 1024px) {
    * {
      max-width: 100%;
      box-sizing: border-box;
    }
    
    body {
      overflow-x: hidden;
      width: 100%;
    }
    
    #root {
      overflow-x: hidden;
      width: 100%;
    }
  }

  /* Fix for iOS Safari viewport height issues */
  @supports (-webkit-touch-callout: none) {
    .mobile-viewport-fix {
      height: -webkit-fill-available;
    }
  }

  /* Prevent text selection on mobile (optional) */
  @media screen and (max-width: 768px) {
    * {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
    
    input, textarea {
      -webkit-user-select: text;
      -khtml-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
    }
  }

  /* Fix for mobile tap highlights */
  * {
    -webkit-tap-highlight-color: transparent;
  }

  /* Ensure proper touch targets on mobile */
  @media screen and (max-width: 768px) {
    button, a, input, select, textarea {
      min-height: 44px;
      min-width: 44px;
    }
  }
`;
